var map = {
	"./cms.js": "8e78",
	"./configuration.js": "948c",
	"./downloadApk.js": "d99b",
	"./home.js": "1a2c",
	"./jzHome.js": "5e95",
	"./news.js": "0e5c",
	"./openPlatform.js": "0745",
	"./servicePay.js": "66a2",
	"./testTrain.js": "72ad",
	"./usercenter.js": "d6e7",
	"./usercenterJz.js": "8bc5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a08a";